import React, { useState } from 'react';
import { Button } from '@alifd/next';
import { EditServiceProps } from './types';
import CategoryDialog from './components/CategoryDialog';

const EditService: React.FC<EditServiceProps> = ({ buttonProps }) => {
  const [showDialog, setShowDialog] = useState(false);
  return (
    <>
      <Button {...(buttonProps || {})} onClick={() => setShowDialog(true)}>
        編輯檔案類型
      </Button>
      <CategoryDialog showDialog={showDialog} setShowDialog={setShowDialog} />
    </>
  );
};

export default EditService;
